import { CourseUserViewModel } from "../coursesApiSlice";
import CourseUsersTable from "./CourseUsersTable";

interface CourseStudentsProps {
	students: CourseUserViewModel[];
}

export default function CourseStudentsSection(props: CourseStudentsProps) {
	return (
		<section>
			<hr className="my-6" />
			<h2>Students</h2>
			<CourseUsersTable users={props.students} displayLength={10} isTeacherTable={false} />
		</section>
	);
}
